import 'core-js/es/array';
import 'core-js/es/map';
import 'core-js/es/object';
import 'core-js/es/promise';
import 'core-js/es/string';
import 'core-js/es/symbol';
import ResizeObserver from 'resize-observer-polyfill';

// draft-js has a dependency on fbjs which relies on:
// https://github.com/facebook/draft-js/issues/2127
import 'core-js/web/immediate';

import 'url-polyfill';

import svg4everybody from 'svg4everybody';

svg4everybody();

if (typeof window !== 'undefined') {
  // draft-js has a dependency on fbjs which relies on:
  // https://github.com/facebook/draft-js/issues/2127
  // @ts-expect-error
  window.global = window;
}

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}
